import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface OrgMemberActivateConfirmDialogData {
  activating?: boolean;
  role?: string;
  action: string;
}

@Component({
  selector: 'app-org-member-activate-confirm-dialog',
  templateUrl: './org-member-activate-confirm-dialog.component.html',
  styleUrls: ['./org-member-activate-confirm-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule, 
    MatDialogModule,
    CommonModule
  ]
})
export class OrgMemberActivateConfirmDialogComponent implements OnInit {

  newMemberRole?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrgMemberActivateConfirmDialogData,
    private dialogRef: MatDialogRef<OrgMemberActivateConfirmDialogComponent>
  ) {}

  ngOnInit() {
    if (this.data.role === 'Org Admin') {
      this.newMemberRole = 'Org Member';
    } else {
      this.newMemberRole = 'Org Admin';
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}